import usuario_model from './usuario_model';
import clasificacion_model from './clasificacion_model';

export default {
  Codigo: null,
  Descripcion: null,
  CodigoSecundario: null,
  Contacto: null,
  Email: null,
  Telefono: null,
  Giro: null,
  Utilidad: null,
  ToleranciaMinima: null,
  ToleranciaMaxima: null,
  Activo: true,
  CodigoUsuarioCreacion: null,
  FechaCreacion: null,
  CodigoUsuarioActualizacion: null,
  FechaActualizacion: null,
  CodigoClasificacion: null,
  CodigoVendedorPrincipal: null,
  CodigoVendedorSecundario: null,
  UsuarioVendedorPrincipal: { ...usuario_model },
  UsuarioVendedorSecundario: { ...usuario_model },
  Clasificacion: { ...clasificacion_model },
};
